import { Box, TabPanel, TabPanelProps, TabPanels } from '@chakra-ui/react'
import moment from 'moment'

import {
  DetailDrawerHeader,
  DetailDrawerList,
  DetailDrawerListMedia,
  DetailDrawerListPaper,
  DetailDrawerListPressRelease,
  DetailDrawerListTrial,
  DetailDrawerSummary,
  DetailDrawerTabs,
} from 'modules/DetailDrawer'

import { SlideOver } from 'components'

import { IResponseBase } from 'api/types'

import { IModel } from 'interfaces/model.interface'
import { ViewData } from 'interfaces/navigationPage.interface'

import {
  PressReleasesModel,
  MediaModel,
  CandidateRankingData,
  PresentationsModel,
} from 'config/common/baseModel'
import { TreatmentClinicalTrialsModel } from 'config/apps/Covid19/Science360/Therapeutics/TreatmentsModels'

const StyledTabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (
  props
) => <TabPanel height='100%' p={0} {...props} />
type PropTypes<D extends Record<CandidateRankingData, any>> = {
  handleClose: () => void
  candidate: IResponseBase<Extract<keyof D, string>>
  model: IModel<D>
  title: Extract<keyof D, string>
  viewData: ViewData
}

function Detail<D extends Record<CandidateRankingData, any>>(
  props: PropTypes<D>
) {
  const { handleClose, candidate, model, title, viewData } = props

  return (
    <SlideOver show={true} handleClose={handleClose}>
      <DetailDrawerHeader
        isLoading={false}
        title={candidate && candidate[title]}
        handleClose={handleClose}
      />
      <DetailDrawerTabs
        tabs={['Summary', 'Media', 'Press Releases', 'Papers', 'Trials']}
      >
        <Box flexGrow={1} flexBasis={0} overflow='hidden'>
          <TabPanels height='100%'>
            <StyledTabPanel p={6} overflow='auto'>
              <DetailDrawerSummary rowData={candidate} model={model} />
            </StyledTabPanel>{' '}
            <StyledTabPanel>
              <DetailDrawerList
                id={1}
                viewData={viewData}
                type='Media'
                model={MediaModel}
                sortOrder={(x) => moment(x.datePublished)}
                ids={candidate.idtreatments360Media}
                itemComponent={DetailDrawerListMedia}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={2}
                viewData={viewData}
                type='PressReleases'
                sortOrder={(x) => moment(x.datePublished)}
                model={PressReleasesModel}
                ids={candidate.idtreatments360PressReleases}
                itemComponent={DetailDrawerListPressRelease}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={3}
                viewData={viewData}
                type='Papers'
                model={
                  { ...PresentationsModel, endpoint: 'publication' } as IModel<
                    any,
                    any
                  >
                }
                sortOrder={(x) => moment(x.publicationDate)}
                ids={candidate.idtreatments360Publications}
                itemComponent={DetailDrawerListPaper}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={4}
                viewData={viewData}
                sortOrder={(x) => moment(x.completedAt)}
                model={TreatmentClinicalTrialsModel}
                ids={candidate.idtreatments360ClinicalTrials}
                itemComponent={DetailDrawerListTrial}
              />
            </StyledTabPanel>
          </TabPanels>
        </Box>
      </DetailDrawerTabs>
    </SlideOver>
  )
}

export default Detail
